var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cover",class:{
  'box-radius': _vm.raduis,
  'box-shadow': _vm.shadow
}},[_c('img',{attrs:{"src":_vm.cover}})])
}
var staticRenderFns = []

export { render, staticRenderFns }